module.exports = __webpack_public_path__ + "img/bg.bb314c3.png";